export { default } from './LandingPageRouter';
